import { useEffect, useState } from 'react';

import { getClient } from 'src/app/state/selectors';
import { useSelector } from 'src/app/state/store';
import type { CheckoutDeliveryWindow } from 'src/app/types';

export function useFetchRescheduleDeliveryWindows(orderId: string): {
  rescheduleDeliveryWindows: CheckoutDeliveryWindow[] | null;
  isLoading: boolean;
  hasError: boolean;
} {
  const [rescheduleDeliveryWindows, setRescheduleDeliveryWindows] = useState<CheckoutDeliveryWindow[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const client = useSelector(getClient);

  useEffect(() => {
    async function fetchRescheduledDeliveryWindows() {
      if (client && orderId) {
        try {
          setHasError(false);
          setIsLoading(true);
          const rescheduledDeliveryWindows: { data: CheckoutDeliveryWindow[] } =
            await client?.getRescheduledDeliveryWindows(orderId);
          setRescheduleDeliveryWindows(rescheduledDeliveryWindows?.data);
          setIsLoading(false);
        } catch (err) {
          setHasError(true);
          setIsLoading(false);
        }
      }
    }
    fetchRescheduledDeliveryWindows();
  }, [client, orderId]);

  return { rescheduleDeliveryWindows, isLoading, hasError };
}
